<script setup lang="ts">
interface Props {
  draggable?: boolean;
  title?: string;
  as?: string;
}

const {
  title,
  draggable = false,
  as = 'span'
} = defineProps<Props>()

const position = defineModel<google.maps.LatLngLiteral>('position', { required: true })

const { loader, map } = assertInject(GoogleMapsInjection)

const marker = shallowRef<google.maps.marker.AdvancedMarkerElement | null>(null)
const markerElement = useTemplateRef<HTMLElement>('markerElement')

onMounted(async () => {
  const { AdvancedMarkerElement } = await loader.importLibrary('marker') as google.maps.MarkerLibrary

  marker.value = new AdvancedMarkerElement({
    position: toValue(position),
    map: map.value,
    title,
    content: markerElement.value,
    gmpDraggable: !!draggable
  })

  marker.value.addListener('dragend', (event: google.maps.MapMouseEvent) => position.value = { lat: event.latLng?.lat() || 0, lng: event.latLng?.lng() || 0 })

  if (marker.value && title) {
    const { InfoWindow } = await loader.importLibrary('maps') as google.maps.MapsLibrary

    const infoWindow = new InfoWindow()

    marker.value.addListener('click', () => {
      infoWindow.close()
      infoWindow.setContent(marker.value?.title || title)
      infoWindow.open(marker.value?.map, marker.value)
    })
  }
})

onBeforeUnmount(() => marker.value!.map = null)

onUnmounted(() => marker.value = null)

provide(GoogleMapsMarkerInjection, {
  marker
})
</script>

<template>
  <component :is="as" ref="markerElement">
    <slot />
  </component>
</template>